var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("emd-card-content", { attrs: { customClass: "eu-pa_3" } }, [
    _c("div", { staticClass: "emd-panel" }, [
      _c("div", { staticClass: "emd-panel__section" }, [
        _c("div", { staticClass: "emd-panel__block" }, [
          _c(
            "div",
            { staticClass: "el-chunk" },
            [
              _c(
                "emd-text",
                { attrs: { type: "caption", size: "medium", tag: "h2" } },
                [_vm._v(_vm._s(_vm.$t("invite.detail.personal-data")))]
              ),
            ],
            1
          ),
        ]),
        _c("div", { staticClass: "emd-panel__block" }, [
          _c(
            "div",
            { staticClass: "el-chunk" },
            [
              _c(
                "emd-text",
                {
                  attrs: {
                    "variation-color": "subtle",
                    type: "label",
                    size: "tiny",
                    tag: "p",
                  },
                },
                [_vm._v(_vm._s(_vm.$t("invite.detail.name")))]
              ),
              _c("emd-text", { attrs: { size: "medium" } }, [
                _vm._v(_vm._s(_vm.invite.invited_name)),
              ]),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "el-chunk" },
            [
              _c(
                "emd-text",
                {
                  attrs: {
                    "variation-color": "subtle",
                    type: "label",
                    size: "tiny",
                    tag: "p",
                  },
                },
                [_vm._v(" " + _vm._s(_vm.$t("invite.detail.email")) + " ")]
              ),
              _c("emd-text", { attrs: { size: "medium" } }, [
                _vm._v(_vm._s(_vm.invite.invited_email)),
              ]),
            ],
            1
          ),
        ]),
      ]),
    ]),
    _c("div", { staticClass: "emd-panel" }, [
      _c("div", { staticClass: "emd-panel__section" }, [
        _c("div", { staticClass: "emd-panel__block" }, [
          _c(
            "div",
            { staticClass: "el-chunk" },
            [
              _c(
                "emd-text",
                { attrs: { type: "caption", size: "medium", tag: "h2" } },
                [_vm._v(_vm._s(_vm.$t("invite.detail.inviter")))]
              ),
            ],
            1
          ),
        ]),
        _c("div", { staticClass: "emd-panel__block" }, [
          _c(
            "div",
            { staticClass: "el-chunk" },
            [
              _c(
                "emd-text",
                {
                  attrs: {
                    "variation-color": "subtle",
                    type: "label",
                    size: "tiny",
                    tag: "p",
                  },
                },
                [
                  _vm._v(
                    " " + _vm._s(_vm.$t("invite.detail.inviter-name")) + " "
                  ),
                ]
              ),
              _c("emd-text", { attrs: { size: "medium" } }, [
                _vm._v(_vm._s(_vm.invite.inviter_name)),
              ]),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "el-chunk" },
            [
              _c(
                "emd-text",
                {
                  attrs: {
                    "variation-color": "subtle",
                    type: "label",
                    size: "tiny",
                    tag: "p",
                  },
                },
                [
                  _vm._v(
                    " " + _vm._s(_vm.$t("invite.detail.inviter-email")) + " "
                  ),
                ]
              ),
              _c("emd-text", { attrs: { size: "medium" } }, [
                _vm._v(_vm._s(_vm.invite.inviter_email)),
              ]),
            ],
            1
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }